import { NextApiRequest } from 'next'
import { MOCKED_ENDPOINTS } from './constants'

export type MockConfig = {
  path: RegExp
  method: string
  delay?: number
  handler: any
  active: boolean
}

export type MockResponse = {
  status: number
  body: unknown
}

export type MockHandler = (req: NextApiRequest) => MockResponse

export function shouldMock(req: NextApiRequest): MockConfig | undefined {
  const path = req.url?.replace(/^\/api\/proxy\//, '') || ''

  return MOCKED_ENDPOINTS.find(
    (mock) =>
      mock.active &&
      mock.path.test(path) &&
      (mock.method === '*' || mock.method === req.method)
  )
}

export async function mockInterceptor(req, res) {
  if (process.env.VERCEL_ENV === 'production') return false
  const mockConfig = shouldMock(req)

  if (mockConfig) {
    if (mockConfig.delay) {
      await new Promise((resolve) => setTimeout(resolve, mockConfig.delay))
    }
    return mockConfig.handler(req, res)
  }

  return false
}
